import RentCalculationBlock from './RentCalculationBlock';

export default RentCalculationBlock;
